import { config } from "src/stateManagement/redux/configVar";


export const deletePlanningActivity = async (id:string) => {
    try {
        
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            planningactivityid: id
        }

        const response = await fetch(`${serverUrl}/api/planning/deletePlanningActivityById`, {
            method: "DELETE",
            headers: headers,
        });

        if (response?.status === 401) {
            return false;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return false;
        }

        const data = await response.json();

        return true;

    } catch (error) {
        console.log({error})
    }
}